import type { VfConfig } from '#types/config/components/vf'

export default {
  iconSize: {
    sm: 'lg',
    md: 'lg',
    lg: 'lg'
  },
} satisfies VfConfig['toast']
